import { defineMessages } from 'react-intl';

export default defineMessages({
	authenticationSuccessful: {
		id: 'dev-agents.github-oauth-redirect.authentication-successful',
		defaultMessage: 'Authentication successful',
		description: 'Title message shown when GitHub OAuth authentication is successful',
	},
	allDoneDescription: {
		id: 'dev-agents.github-oauth-redirect.all-done-description.code-reviewer',
		defaultMessage:
			"You're all done. Code Reviewer is ready to review your pull requests in GitHub.",
		description: 'Description message indicating setup is complete and Code Reviewer is ready',
	},
	resubmitPullRequestInstructions: {
		id: 'dev-agents.github-oauth-redirect.resubmit-pull-request-instructions',
		defaultMessage: 'Resubmit your pull request, or create a new one, to trigger a code review.',
		description:
			'Instructions for users to resubmit or create a pull request to trigger code review',
	},
	backToGitHubButton: {
		id: 'dev-agents.github-oauth-redirect.back-to-github-button',
		defaultMessage: 'Back to GitHub',
		description: 'Label for the button that navigates the user back to GitHub',
	},
	authenticationFailed: {
		id: 'dev-agents.github-oauth-redirect.authentication-failed',
		defaultMessage: 'Authentication failed',
		description: 'Title message shown when GitHub OAuth authentication fails',
	},
	authenticationErrorDescription: {
		id: 'dev-agents.github-oauth-redirect.authentication-error-description',
		defaultMessage: 'There was an error during authentication. Please try again.',
		description: 'Description message shown when authentication fails',
	},
});
